$shm_dashboard_admin_book $mol_book2
	section? \users
	placeholders /
	pages <= admin_pages /
	Menu $mol_page
		title \Администрирование
		body /
			<= Navigation $mol_view
				sub /
					<= Users_link $mol_link
						arg *
							admin_section \users
						title \Пользователи
						current <= users_current false
					<= Wordstat_link $mol_link
						arg *
							admin_section \wordstat
						title \Wordstat
						current <= wordstat_current false
	Users $shm_dashboard_admin_users
	Wordstat $shm_dashboard_admin_wordstat
